import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from '../../../../services/company.service';
import { SubscriptionService } from '../../services/subscription.service';
import { orgServiceModel } from '../../models';
import { NtCompany } from '../../models/nt-company';

@Component({
  selector: 'app-subscription-invalid-payment-bar',
  templateUrl: './subscription-invalid-payment-bar.component.html',
  styleUrls: ['./subscription-invalid-payment-bar.component.scss']
})
export class SubscriptionInvalidPaymentBarComponent implements OnInit, OnDestroy {
    sub = new Subject();
    showBar = false;
    invalidPayment = false;
    cardExpiring = false;
    orgId = '';
    subId = 0;


    constructor(private comp: CompanyService,
            private subSvc: SubscriptionService
    ) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(takeUntil(this.sub)).subscribe(c => {
            this.updateView(c);
        });
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete(); 
    }

    get paymentUrl(){
        return ['/account', 'organisation', this.orgId, 'subscription',this.subId, 'payment-method'];   //
    }

    async updateView(c: NtCompany) {
        if (c) {
            if (c.subscribedService) {
                this.setProperties(c.subscribedService, c.billingOrganisationId);
                
            } else {
                //We're going to have to get the service
                const u = await this.subSvc.getUserOrganisation(c.billingOrganisationId);
                if(u){
                    const s = u.services.find(x => x.id === c.subscribedServiceId);
                    this.setProperties(s, c.billingOrganisationId);
                }
            }
        } else {
            this.invalidPayment = false;
        }
      }
    
    setProperties(s: orgServiceModel, id: string) {
        this.invalidPayment = s.paymentState === 'RetryPending' || (!s.suspended && s.paymentState === 'InvalidPaymentType');
        if(!this.invalidPayment){
            //We don't want to set both bools, so only if sub says payment is ok do we continue
            this.cardExpiring = s.cardExpiring;
        }

        this.showBar = this.cardExpiring || this.invalidPayment;
        this.orgId = id;
        this.subId = s.id;
    }


}
